<template>
  <div class="container">
    <form ref="form" @submit.prevent="onSubmit">
        <div id="top-container" class="container columns is-desktop">
          <div id="spending-container" class="column" >
            <spending />
          </div>
          <!-- <div id="promo-container" class="column">
            <div v-html="getContentSnippet('promo-content')">
            </div>
          </div> -->
        </div>
        <div id="input-container" class="container columns is-desktop">
            <div class="column is-one-third-desktop has-right-border">
                <demographics ref="demographics" />
            </div>
            <div class="column is-one-third-desktop has-right-border">
              <savings v-show="getPlanType === null" ></savings>
              <savings-plan v-show="getPlanType !== null" ></savings-plan>
            </div>
            <div class="column is-one-third-desktop">
                <income />
            </div>
        </div>
                    <div>
                <div id="calculate-button-container">
                    <button :disabled="errors.any()" class="button is-primary is-fullwidth bigbutton">Calculate Your Retirement Strategy</button>
                </div>
            </div>
    </form>
    <b-modal id="help-video" :active="youtubeModalActive" scroll="keep" :onCancel="() => this.youtubeModalActive = false">
      <div v-html="getContentSnippet('input-tutorial-1')">
      </div>
    </b-modal>
  </div>
</template>

<script>
import Demographics from '@/components/Demographics'
import Savings from '@/components/Savings'
import SavingsPlan from '@/components/SavingsPlan'
import Income from '@/components/Income'
import Spending from '@/components/SpendingSlider'
import { MonthlyApiService } from '@/services/MonthlyApiService'
import { mapGetters, mapActions } from 'vuex'
import { Tweet } from 'vue-tweet-embed'

const monthlyApiService = new MonthlyApiService()

export default {
  name: 'quickstartForm2',
  components: {
    Demographics,
    Savings,
    SavingsPlan,
    Income,
    Spending,
    Tweet
  },
  data () {
    return {
      submitted: false,
      helpSnackbarVisible: false,
      youtubeModalActive: false,
      videoId: 'NpEaa2P7qZI'
    }
  },
  watch: {
    helpSnackbarVisible: function (val) {
      if (val) {
        this.showHelpSnackbar()
      }
    }
  },
  computed: {
    ...mapGetters([
      'getContentSnippet',
      'getPlanType',
      'getUseGetMoreTeaser'
    ])
  },
  methods: {
    ...mapActions({
      moveStep: 'moveStep',
      setGetMoreTeaserModalActive: 'setGetMoreTeaserModalActive'
    }),
    onSubmit () {
      this.moveStep('1')
      this.$tours['inputTour'].stop()
      monthlyApiService.startQuickstart().then((response) => {
        this.$store.dispatch('updateRequestHash', response.data.payload)
        monthlyApiService.startOptimize().then((response) => {
          this.$store.dispatch('updateQuickstartResults', response.data.payload)
          if (this.$store.getters.getUseGetMoreTeaser) {
            this.setGetMoreTeaserModalActive(true)
          } else {
            this.$router.push({ path: 'results' })
          }
        }
        )
      }
      )
    },
    showHelpSnackbar () {
      if (this.getPlanType === '401k' && !this.youtubeModalActive) {
        if (!this.$cookies.isKey('show_snackbar_count') ||
          parseInt(this.$cookies.get('show_snackbar_count')) <= 3) {
          this.$snackbar.open({
            message: 'Would you like to see a brief tutorial?',
            type: 'is-success',
            position: 'is-top',
            actionText: 'Yes',
            indefinite: false,
            duration: 30000,
            onAction: () => {
              this.youtubeModalActive = true
            }
          })
          let snackbarCount = (!this.$cookies.isKey('show_snackbar_count')) ? 1 : 1 + parseInt(this.$cookies.get('show_snackbar_count'))
          console.log(snackbarCount)
          this.$cookies.set('show_snackbar_count', snackbarCount.toString())
        }
      }
    },
    playVideo () {
      this.$refs.player.player.playVideo()
    },
    pauseVideo () {

    }
  },
  mounted () {
    this.$store.dispatch('clearDirtyForm')
  },
  onIdle () {
    this.helpSnackbarVisible = true
  },
  onActive () {
    this.helpSnackbarVisible = false
  }
}
</script>

<style lang="scss">
$snackbar-background-color: #ffffff;

#top-container, #input-container {
  margin: 10px;
}
#input-container, #spending-container {
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border: 1px solid black;
}
#spending-container {
  margin:0 5px 25px 0;
}
#promo-container {
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  margin-left: 5px;
}
#calculate-button-container {
  padding: 0px 15px;
  margin-top:25px;
}

#help-video .modal-content {
  overflow: hidden;
}

@media (min-width: 769px) {
  .has-right-border {
    border-right: 1px solid #dbdbdb;
  }
}

@media (max-width: 768px) {
  .has-right-border {
    border-bottom: 1px solid #dbdbdb;
  }
}
</style>
